module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0016.jpg?v=a21a8b47";